module.exports = __webpack_public_path__ + "img/symbol_3.ce62428f.png";